import bars from './bars.inline.svg';
import times from './times.inline.svg';

export default {
  bars,
  times,
};
